import { BaseDSLVisitor } from './baseDSL.visitor';
import { ParameterPlainObject } from '../plainObjects/parameter.plainObject';
import { SchemaUtil } from '../utils/schema.util';

/* eslint-disable @typescript-eslint/no-explicit-any */
export class ParametersVisitor extends BaseDSLVisitor {

    constructor(protected _tokenStream: any, public parameters: ParameterPlainObject[]) {
        super(_tokenStream);
    }

    public visitParameters(context: any): void {
        this.visitChildren(context);
    }

    public visitParameterDefinition(context: any): void {
        const parameter = new ParameterPlainObject();
        parameter.defaultValue = context.expression() ? context.expression().getText() : undefined;
        parameter.name = context.parameter().getText();
        parameter.dataType = SchemaUtil._getColumnDataType(context.datatype());
        this.parameters.push(parameter);
    }
}
